var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm, FormProvider, Controller, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useMaskito } from "@maskito/react";
import FormActions from "../FormActions";
import { RequiredStringSchema, REQUIRED_MESSAGE } from "../../../utils/schemas";
import { digitsOnlyMask } from "../../../utils/masks";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Combobox, RadioButton, Stepper, TextField, useStepper, } from "@opala-ds/react";
import { TechnicalSchoolCitySelect } from "./TechnicalSchoolCitySelect";
import TechnicalSchoolNameSelect from "./TechnicalSchoolNameSelect";
import { CollectivesModalitys, InfantilIndividualsModalitys, InfantoIndividualsModalitys, } from "../../../utils/constraints/Modalitys";
var Schema = z.object({
    genero_modalidade: RequiredStringSchema,
    categoria: RequiredStringSchema,
    modalidade: RequiredStringSchema,
    escola: z.object({
        id: z.number({ message: REQUIRED_MESSAGE }),
        inep: z
            .string()
            .trim()
            .nonempty(REQUIRED_MESSAGE)
            .min(8, "O código deve conter 8 dígitos"),
        municipio: RequiredStringSchema,
    }),
});
export default function TechnicalSchoolDataForm(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var onSubmit = _a.onSubmit, _p = _a.defaultValues, defaultValues = _p === void 0 ? {
        genero_modalidade: "",
        categoria: "",
        modalidade: "",
        escola: {
            inep: "",
            municipio: "",
        },
    } : _p;
    var _q = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), watch = _q.watch, handleSubmit = _q.handleSubmit, register = _q.register, _r = _q.formState, errors = _r.errors, formStateRest = __rest(_r, ["errors"]), formRest = __rest(_q, ["watch", "handleSubmit", "register", "formState"]);
    var nextStep = useStepper().nextStep;
    var inepEscolaMaskRef = useMaskito({ options: digitsOnlyMask });
    var isMobile = useIsMobile();
    var modalities = Array.from(new Set(__spreadArray(__spreadArray(__spreadArray([], CollectivesModalitys, true), InfantilIndividualsModalitys, true), InfantoIndividualsModalitys, true)));
    return (_jsx(FormProvider, __assign({ handleSubmit: handleSubmit, register: register, watch: watch, formState: __assign({ errors: errors }, formStateRest) }, formRest, { children: _jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(data);
                            return [4 /*yield*/, onSubmit(data)];
                        case 1:
                            _a.sent();
                            nextStep();
                            return [2 /*return*/];
                    }
                });
            }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-3 gap-4" }, { children: [_jsx(TechnicalSchoolCitySelect, {}), _jsx(TechnicalSchoolNameSelect, {}), _jsx(TextField, __assign({ label: "INEP da escola", placeholder: "Digite o c\u00F3digo INEP", size: "md", helperText: (_d = (_c = (_b = errors.escola) === null || _b === void 0 ? void 0 : _b.inep) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : "", variant: ((_e = errors.escola) === null || _e === void 0 ? void 0 : _e.inep) ? "critical" : "default", disabled: true }, register("escola.inep"), { ref: function (node) {
                                        inepEscolaMaskRef(node);
                                        register("escola.inep").ref(node);
                                    } }))] })), _jsx(Controller, { control: formRest.control, name: "modalidade", render: function (_a) {
                                var _b, _c;
                                var _d = _a.field, onChange = _d.onChange, value = _d.value;
                                return (_jsx(Combobox, { label: "Modalidade", placeholder: "Selecione", containerClassName: "[&>button>div]:text-[#262626]", items: modalities.map(function (modalidade) { return ({
                                        label: modalidade,
                                        value: modalidade,
                                    }); }), helperText: (_c = (_b = errors.modalidade) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.modalidade ? "critical" : "default", value: value, onSelectValue: onChange }));
                            } }), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsxs("div", __assign({ className: "flex flex-col gap-3" }, { children: [_jsx("span", __assign({ className: "text-sm font-semibold" }, { children: "G\u00EAnero" })), _jsx(RadioButton, __assign({ label: "Feminino", value: "F" }, register("genero_modalidade"), { helperText: (_g = (_f = errors.genero_modalidade) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : "", variant: errors.genero_modalidade ? "critical" : "info" })), _jsx(RadioButton, __assign({ label: "Masculino", value: "M" }, register("genero_modalidade"), { helperText: (_j = (_h = errors.genero_modalidade) === null || _h === void 0 ? void 0 : _h.message) !== null && _j !== void 0 ? _j : "", variant: errors.genero_modalidade ? "critical" : "info" }))] })), _jsxs("div", __assign({ className: "flex flex-col gap-3" }, { children: [_jsx("span", __assign({ className: "text-sm font-semibold" }, { children: "Categoria" })), _jsx(RadioButton, __assign({ label: "12 a 14 anos - Infantil", value: "INFANTIL" }, register("categoria"), { helperText: (_l = (_k = errors.categoria) === null || _k === void 0 ? void 0 : _k.message) !== null && _l !== void 0 ? _l : "", variant: errors.categoria ? "critical" : "info" })), _jsx(RadioButton, __assign({ label: "15 a 17 anos - Infanto", value: "INFANTO" }, register("categoria"), { helperText: (_o = (_m = errors.categoria) === null || _m === void 0 ? void 0 : _m.message) !== null && _o !== void 0 ? _o : "", variant: errors.categoria ? "critical" : "info" }))] }))] }))] })), _jsx(FormActions, {})] })) })));
}
